export const DOCS_URL = process.env.NEXT_PUBLIC_DOCS_URL ?? "https://docs.slant.app"
